<template>
  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl zndx"
    :class="isRTL ? 'me-3 rotate-caret' : 'ms-3 my-element'"
    id="sidenav-main"
  >
    <!--  -->
    <div class="sidenav-header" style="padding: 10px 12px">
      <div
        style="
          background-color: rgb(210, 250, 246);
          border-radius: 10px;
          display: flex;
          align-items: center;
          padding: 10px;
          gap: 10px;
        "
      >
        <!-- Logo -->
        <div
          style="
            flex: 0 0 50px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <img
            :src="
              $store.getters.currentLogo == null ||
              $store.getters.currentLogo == ''
                ? logo
                : $store.getters.currentLogo
            "
            alt="main_logo"
            style="
              max-height: 45px;
              max-width: 45px;
              object-fit: contain;
              border-radius: 6px;
            "
          />
        </div>

        <!-- Company Name -->
        <div
          style="
            flex: 1;
            font-size: 1.1em;
            font-weight: 600;
            color: #2c3e50;
            line-height: 1.3;

            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            word-break: break-word;
          "
        >
          {{ $store.getters.currentCompany || "Company Name" }}
        </div>
      </div>
    </div>
    <!-- <div class="sidenav-header">
      <div style="background-color: rgb(210, 250, 246)" class="row">
        <div class="col-sm-4 pr-0 mr-0 center-img">
          <img
            :src="
              $store.getters.currentLogo == null ||
              $store.getters.currentLogo == ''
                ? logo
                : $store.getters.currentLogo
            "
            class="navbar-brand-img-mine"
            alt="main_logo"
          />
        </div>

        <div style="font-size: 1.4em" class="col-sm-8 pl-0 ml-0">
          {{ truncateText($store.getters.currentCompany, 24) }}
        </div>
      </div>
    </div> -->
    <hr class="mt-0 horizontal dark" />
    <sidenav-list :cardBg="customClass" />
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";
// import logo from "@/assets/img/logo-ct.png";
import logo from "@/assets/img/org.png";
import { mapState } from "vuex";

export default {
  name: "index",
  components: {
    SidenavList,
  },
  data() {
    return {
      logo,
    };
  },
  props: {
    customClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState(["isRTL"]),
  },
  methods: {
    truncateText(text, maxLength) {
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + "...";
      }
      return text;
    },
  },
  mounted() {
    const company = this.$store.getters.currentLogo;
    console.log("finding this=====");

    console.log(company);
    console.log(window.location.origin);
  },
};
</script>

<style scoped>
.my-element {
  /* width: 200px;
  height: 100vh; */
  background-color: #eee;
  overflow: auto; /* Show scrollbar when needed */
}

.my-element::-webkit-scrollbar {
  width: 0px; /* Adjust width as needed */
}

.my-element::-webkit-scrollbar-thumb {
  background-color: #ddd; /* Adjust color as needed */
  border-radius: 5px; /* Add rounded corners */
}

.my-element::-webkit-scrollbar-track {
  background-color: #eee; /* Adjust track color as needed */
}

.zndx {
  z-index: 1;
}
.navbar-brand-img-mine {
  border-radius: 50%;
  height: 100%;
  max-height: 5em;
  width: auto;
  object-fit: cover;
}
.center-img {
  display: flex;
  justify-content: center;
  /* align-items: center; */
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}
</style>
